<template v-if="globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker'">
	<include-header />
	<ModalRefuse />

	<section id="lab_charge">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">청구서 미발행 내역</div>
					<div class="searchBox">
						<form ref="form_search" id="form_search" @submit.prevent="getModels()">
							<div class="searchRow">
								<div class="searchCont">
									<label for="dentalPartnerSearch" class="form-label required">{{ other_type }}명</label>
									<input type="text" class="form-control" v-model="searchModels.partner"
										id="dentalPartnerSearch" :placeholder="`${other_type}명`">
								</div>
								<div class="searchCont">
									<label for="orderDateSearch" class="form-label required">출고일</label>
									<input type="date" class="form-control" id="orderComplateDateSearch"
										v-model="searchModels.orderComplateDateSearch" value="">
									<span class="hyphen">-</span>
									<input type="date" class="form-control" id="orderComplateDateSearch2"
										v-model="searchModels.orderComplateDateSearch2" value="">
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn" @click.prevent="getModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
								</div>
							</div>
						</form>
					</div>
					<div class="sub_contBox">
						<form ref="form_charge_list" id="form_charge_list" action="`/charge_publish"
							@submit.prevent="form_charge_list_submit()" method="post" autocomplete="off"
							target="charge_publish">
							<input type="hidden" name="checked_id">

							<div class="subTitWrap">
								<div class="subTit">[청구서 미발행 목록]</div>
								<ul class="subBtn">
									<li><button type="button" id="PublishBtn" @click="form_charge_list_submit()">청구서 발행</button></li>
								</ul>
							</div>

							<table>
								<thead>
									<tr>
										<th class="chkBox"><input type="checkbox" @click="checkAll($event)" id="chk_all"></th>
										<th class="cols1">접수번호</th>
										<th class="cols2">주문일</th>
										<th class="cols3">출고 완료일</th>
										<th class="cols4">{{ globaljs.acc_type === 'lab' ? '치과' : '기공소' }}</th>
										<th class="cols5">환자명</th>
										<th class="cols6">청구서상태</th>
										<th class="cols7">정산유형</th>
										<th class="hidden_cell">정산유형</th>
									</tr>
								</thead>
								<tbody :class="HZwrapper">
									<tr v-if="paginatedItems.length > 0" v-for="(item, index) in paginatedItems" :key="item.id" class="tableItem">
										<td class="cols_chk">
											<input type="checkbox" :name="'chk[]'" class="chk" :value="item.id" :data-hos_id="item.hospital_mb_id">
											<!-- // @change="handleCheckboxChange(item.id) -->
										</td>
										<td class="cols1">{{ item.aiorder_no }}</td>
										<td class="cols2">{{ commonjs.dateFormatYMD(orderJsonData[item.id].registerDate) }}</td>
										<td class="cols3">{{ commonjs.isValidDateTime(item.order_complete_datetime) ? commonjs.dateFormatYMD(item.order_complete_datetime) : '-' }}</td>
										<td class="cols4">{{ item.memberAiorder_Hospital ? item.memberAiorder_Hospital.mb_nick : item.memberAiorder_Lab.mb_nick }}</td>
										<td class="cols5">{{ orderJsonData[item.id].patientName }}</td>
										<td class="cols6">{{ status_t(item.bill_status) }}</td>
										<td class="cols7">{{ status_t2(item.calc_status) }}</td>
										<td class="hidden_cell">{{ item.hospital_mb_id }}</td>
									</tr>
									<tr v-else>
										<td colspan="9">데이터가 없습니다.</td>
									</tr>
								</tbody>
							</table>

							<div class="page">
								<ul :id="HZpaginationId" class="pagination">
									<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
									<li>
										<ul class="num_wrap">
											<li v-for="page in pagesToShow" :key="page" :class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']" @click="goToPage(page)">
												{{ page }}
											</li>
										</ul>
									</li>
									<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
								</ul>
							</div>

						</form>
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import ModalRefuse from '@/components/layout/modal_refuse_data.vue';

const route = useRoute();
const router = useRouter();

if(globaljs.acc_type === 'hospital' || globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

let form_search = ref(null)
let searchModels = ref({})

onMounted(async () => {
	if(globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker') {
		await getModels();
	}
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = '';
		selectElement.selected = true;
	});

	await getModels();
}

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	return Object.values(searchModels.value).some(value => value !== '');
});

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const checkAll = (event) => {
	const checkboxes = document.querySelectorAll('.chk');
	checkboxes.forEach(checkbox => {
		checkbox.checked = event.target.checked;
	});
};

const status_t = ((status) => {
	let text = '';
	switch (status) {
		case 'bils1':
			text = '승인';
			break;
		case 'bils2':
			text = '발행';
			break;
		case 'bils3':
			text = '미발행';
			break;
		case 'bils4':
			text = '반려';
			break;

		default:
			text = '-';
			break;
	}
	return text;
});

const status_t2 = ((status) => {
	let text = '';
	switch (status) {
		case 'type1':
			text = '정산대기';
			break;
		case 'type2':
			text = '정산완료';
			break;

		default:
			text = '-';
			break;
	}
	return text;
});

// 각 체크박스의 상태를 변경할 때마다 이 함수가 호출되도록 설정
function updateCheckedIds() {
	const checked_id_input = document.querySelector('input[name="checked_id"]');
	const formElement = document.getElementById('form_charge_list');
	
	// 체크된 체크박스의 값을 담을 배열
	const checkedValues = [];

	// 체크된 체크박스의 값을 배열에 추가
	formElement.querySelectorAll('input[type="checkbox"]').forEach((input) => {
		if (input.type === 'checkbox' && input.id !== 'chk_all' && input.checked) {
			checkedValues.push(input.value);
		}
	});

	// checked_id_input의 값을 새로 갱신
	checked_id_input.value = checkedValues.join(',');
}

const items = ref([]);
const orderJsonData = ref([]);

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type); // 240905 이걸 넣어야해
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('progressSearch', 'ords3'); // 출고 완료된 것만
	params.append('noBill', true); // 청구 하지 않은것
	params.append('orderBy', 'order_complete_datetime'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
		currentPage.value = 1; // 240822 1페이지로 고정
		for (let i = 0; i < items.value.length; i++) {
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value[i].order_json_data);
			orderJsonData.value[items.value[i].id] = JSON.parse(sanitizedData);
		}
	} catch (error) {
console.error('Error getModels:', error);
	}
}

async function form_charge_list_submit() {
	await withSubmitFlag(async () => {
		const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
		// enabledInputs의 길이를 카운팅합니다.
		const count = enabledInputs.length;
		if (count < 1) {
			commonjs.formSwal('필수 선택', '청구서 발행 할 항목을 하나 이상 선택해주세요.', '#chk_all', 'self');
			return false;
		}

		// document.querySelectorAll("input[type='checkbox'].chk").forEach(function (checkbox) {
		// 	checkbox.addEventListener('change', function () {
		// var enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
		var not_same_cnt = 0;
		var prev_hospital_mb_id = "";

		enabledInputs.forEach(function (checkbox, index) {
			var hospitalId = checkbox.dataset.hos_id;

	console.debug(index, prev_hospital_mb_id, hospitalId);

			if (index === 0) {
				prev_hospital_mb_id = hospitalId;
			} else {
				if (prev_hospital_mb_id !== hospitalId) {
					commonjs.formSwal('발행 실패', '동일한 치과의 주문서끼리만 청구서 발행이 가능합니다.');
					document.querySelectorAll("input[type='checkbox'].chk").forEach(function (box) {
						box.checked = false;
					});
					document.getElementById("chk_all").checked = false;
					not_same_cnt++;
					return false; // loop exit
				}
				prev_hospital_mb_id = hospitalId;
			}
		});

		if (not_same_cnt !== 0) {
			return false;
		}

		const formElement = document.getElementById('form_charge_list');
		const essentials = formElement.querySelectorAll('[required]');
		for (const element of essentials) {
			if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
				return false;
			}

			// input type="date"의 경우 날짜 형식 검증
			if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
				return false;
			}
		}

		/*
		formElement.querySelectorAll('input').forEach((input) => {
			if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
				if (input.checked) {
					if (checked_id_input.value === '') {
						checked_id_input.value = input.value;
					} else {
						checked_id_input.value += ',' + input.value;
					}
				}
			}
		});
		*/

		// 폼 제출 시 업데이트된 checked_id_input의 값을 사용하도록 호출
		updateCheckedIds();
		const checked_id_input = document.querySelector('input[name="checked_id"]');

		try {
			commonjs.chargePopup(`/charge_publish/${checked_id_input.value}`);
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>